import { type ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { i18n } from '@shared/i18n';
import { env } from '@shared/config/env';
import { queryClient } from './query-client';
import { AuthBootstrap } from './auth-bootstrap';
import { WsBootstrap } from './ws-bootstrap';
import { ErrorBoundary } from './error-boundary';
import { ThemeProvider } from './theme-provider';

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary>
      <I18nextProvider i18n={i18n}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <ThemeProvider>
              <AuthBootstrap>
                <WsBootstrap>{children}</WsBootstrap>
              </AuthBootstrap>
            </ThemeProvider>
          </BrowserRouter>
          {env.isDev ? <ReactQueryDevtools initialIsOpen={false} /> : null}
        </QueryClientProvider>
      </I18nextProvider>
    </ErrorBoundary>
  );
}
